module.exports = [{
      plugin: require('/opt/build/repo/frontend/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"Iamnotvalid","head":false,"anonymize":true,"respectDNT":true},
    },{
      plugin: require('/opt/build/repo/frontend/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
